<template>
    <div>
        <div class="wrap join-wrap">
            <div class="join-form">
                <div class="title-txt">
                    <h3>Bnb가 처음이시군요!</h3>
                    <p>
                        Bnb가 처음이시군요! <br>
                        아래 간단한 정보를 입력하시면 <br>
                        바로 시작할 수 있습니다.
                    </p>
                </div>
                <ul>
                    <li>
                        <input type="text" placeholder="이름을 입력해 주세요.">
                    </li>
                    <li>
                        <input type="text" placeholder="연락처를 입력해 주세요.">
                    </li>
                    <li>
                        <input type="password" placeholder="비밀번호를 입력해 주세요">
                    </li>
                    <p class="txt-red">영문+숫자+특수문자 8자리 이상으로 입력해 주세요.</p>
                    <li>
                        <input type="password" placeholder="비밀번호를 입력해 주세요">
                    </li>
                    <!-- 비밀번호가 틀렸을 경우 -->
                    <!-- <p class="txt-red">동일한 비밀번호를 입력해 주세요.</p> -->
                </ul>
                <div class="user-agree-wrap">
                    <div class="user-agree">
                        <input type="checkbox" name="" id="">
                        <span>개인정보 이용 및 수집 동의 (필수)</span>
                    </div>
                    <div class="user-agree">
                        <input type="checkbox" name="" id="">
                        <span>회원 이용약관 동의 (필수)</span>
                    </div>
                </div>
            </div>

            <div class="bnb-btn">
                <!-- 입력 시 class="active" 활성화 -->
                <button>로그인</button>
            </div>
        </div>
    </div>

</template>
<script>
    export default {
        name :'join',
        data: () => ({
        }),
        components: {
        },
        mounted() {
        },
        methods: {
        }
    }
</script>